<template>
  <v-skeleton-loader :loading="showLoader" type="card-avatar, article" style="background-color: transparent">
    <v-card width="100%">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea v-model="newNote" label="Notes" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn :disabled="!newNote || newNote.trim() === ''" @click="addNote">{{ addNoteButtonLabel }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script setup>
import { ref } from "vue";
import { userNotesService } from "@/services/userNotesService";

const showLoader = ref(false);
const newNote = ref("");
const errorMsg = ref("");

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  orderInfoId: {
    type: String,
    required: false,
    default: null,
  },
  intakeOrderId: {
    type: Number,
    required: false,
    default: null,
  },
  intakeDocumentId: {
    type: String,
    required: false,
    default: null,
  },
  onAddNote: {
    type: [Function, null],
    required: false,
    default: null,
  },
  overrideAddNote: {
    type: [Function, null],
    required: false,
    default: null,
  },
  addNoteButtonLabel: {
    type: String,
    required: false,
    default: "Add Note",
  },
});

const addNote = async () => {
  try {
    if (props.overrideAddNote) {
      await props.overrideAddNote(newNote.value.trim(), {
        orderInfoId: props.orderInfoId,
        intakeOrderId: props.intakeOrderId,
        intakeDocumentId: props.intakeDocumentId,
      });
      return;
    }
    errorMsg.value = "";
    showLoader.value = true;
    const createdNote = await userNotesService.createNote({
      orderInfo: props.orderInfoId,
      intakeOrder: props.intakeOrderId,
      intakeDocument: props.intakeDocumentId,
      note: newNote.value.trim(),
    });
    newNote.value = "";
    if (props.onAddNote) {
      props.onAddNote(createdNote);
    }
  } catch (e) {
    errorMsg.value = `Failed to add note: ${e.message}`;
  } finally {
    showLoader.value = false;
  }
};
</script>
